import React from 'react';
import { useTranslation } from 'react-i18next';

const TopBar: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-gradient-to-r from-primary-dark via-primary to-primary-light text-white py-2.5 px-4 text-center text-sm font-medium tracking-wide shadow-inner">
            <p>{t('common.freeShippingPromo')}</p>
        </div>
    );
};

export default TopBar;
